module.exports = __webpack_public_path__ + "static/media/yaffotlv_thumb_even.1bafd63b.webp";